<template>
  <div class="app">
    <mobile />
    <Modal v-if="modal.show || loading" class="fadeIn animated">
      <Rule v-if="modal.type === 'rule'"></Rule>
      <Bind v-if="modal.type === 'bind'"></Bind>
      <Share v-if="modal.type === 'share'"></Share>
      <Copy v-if="modal.type === 'copy'" :copy="modal.copy"></Copy>
      <Win v-if="modal.type === 'win'" :win="modal.win"></Win>
      <Times v-if="modal.type === 'times'"></Times>
      <Prize v-if="modal.type === 'prize'" :prize="modal.prize"></Prize>
      <Loading v-if="loading" />
    </Modal>
    <Orientation v-if="isMobile" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
// import Loading from '~/components/loading.vue';
import mobile from '~/views/index.vue'
// import Loading from '~/components/Loading/loading.vue';
import Loading from '~/components/loading.vue';
import Win from '~/components/Win/index.vue';
import Prize from '~/components/Prize/index.vue';
import Copy from '~/components/copy/index.vue';
import Share from '~/components/Share/index.vue';
import Times from '~/components/Times/times.vue';
import Bind from '~/components/Bind/bind.vue';
import Modal from '~/components/Modal/modal.vue';
import Rule from '~/components/Rule/index.vue';
import Orientation from '~/components/Orientation/orientation.vue';
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import alert from '~/components/Alert';
import confirm from '~/components/Confirm';
import imgUrl from './images/share.png';
import 'animate.css/animate.min.css';
import '@babel/polyfill';
import { isMobile, rem, loadImage } from '~/tools/utils'
import {FastClick} from 'fastclick'
//FastClick的ios点击穿透解决方案
FastClick.prototype.focus = function (targetElement) {
    let length;
    if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
        length = targetElement.value.length;
        targetElement.focus();
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
};

Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;

export default {
  components: {
    Loading,
    Modal,
    Orientation,
    Win,
    Prize,
    mobile,
    Share,
    Times,
    Bind,
    Copy,
    Rule
  },
  data() {
    return {
      isMobile: isMobile(),
      show: false
    }
  },
  computed: {
    ...mapState({
      modal: state => state.modal,
      loading: state => state.loading,
      showGuide: state => state.showGuide,
      alert: state => state.alert
    })
  },
  created() {
    console.log('loading app');
    FastClick.attach(document.body);
    store.commit(types.SHOW_LOADING, true);
    // 解决ios输入之后键盘收起后留白
    if(this.isMobile) {
      document.body.addEventListener('focusout', function() {
        window.scrollTo(0, document.documentElement.clientHeight);
      });
      // document.addEventListener('touchmove', function(e){
      //   e .preventDefault();
      // }, {passive: false})
    }
    this.show = true;

    // requirejs(["weixin/main"],function(weixin){
    //   var appid = 'wx0fcf7f47419c8171';
    //   window.wx = new weixin(appid,function(){});
    // })

    rem(750);
  },
  methods: {
    closeAlert() {
      store.commit(types.HIDE_ALERT);
    },
    close() {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

<style rel="stylesheet/stylus" lang="stylus">
    // @media screen and (orientation:landscape) {
    //     html {
    //         font-size: 6.25vw;
    //     }
    // }

    // @media screen and (orientation:portrait) {
    //   html {
    //     font-size: 13.333333333333336vw;
    //   }
    // }
    .app
        width 100%
    ::-webkit-scrollbar
        width: 6px;
        height: 6px;
        /* background-color:#fff; */
        display: none;

    ::-webkit-scrollbar:hover
        background-color: #eee;

    ::-webkit-scrollbar-thumb
        // margin-right 10px
        // margin-top 33px
        min-height: 6px;
        min-width: 6px;
        -webkit-border-radius: 20px;
        border: 1px solid #eac474;
        background-color: #eac474;

    ::-webkit-scrollbar-thumb:hover
        min-height: 6px;
        min-width: 6px;
        -webkit-border-radius: 3px;
        border: 1px solid #444;
        background-color: #444;

    ::-webkit-scrollbar-thumb:active
        -webkit-border-radius: 3px;
        border: 1px solid #444;
        background-color: #444;
</style>
